<template>
  <v-content>
    <v-skeleton-loader v-if="isLoading" type="card" class="mx-auto" max-width="90%" />
    <v-form v-if="!isLoading" ref="form">
      <v-row v-if="mostrarEstado">
        <v-col cols="12" sm="6" md="5" class="mx-auto">
          <v-text-field v-bind:value="pantalla.estado" readonly outlined label="Estado de la solicitud"></v-text-field>
        </v-col>

        <v-col cols="12" sm="6" md="5" class="mx-auto">
          <v-text-field v-bind:value="pantalla.firma ? formatLocalDateTime(pantalla.firma) : ''" readonly outlined
            label="Fecha de solicitud"></v-text-field>
        </v-col>

        <v-col cols="12" sm="6" md="5" class="mx-auto">
          <v-text-field v-bind:value="pantalla.email" readonly outlined label="Correo electrónico"></v-text-field>
        </v-col>

        <v-col cols="12" sm="6" md="5" class="mx-auto">
          <v-text-field v-bind:value="pantalla.movil" readonly outlined label="Teléfono móvil"></v-text-field>
        </v-col>
      </v-row>

      <!-- listado de certificados -->
      <v-row v-if="listCertificados.length > 0">
        <v-col v-for="(certificado, index) in listCertificados" cols="11" sm="9" :key="index" class="mx-auto file-row"
          @click="downloadCertificado(certificado)">
          <span class="file-name">{{ certificado.titulo }}</span>
          <span v-if="!certificado.nombreFichero" class="file-date">Documento no adjuntado</span>
          <span v-if="certificado.nombreFichero" class="file-date">
            {{ certificado.nombreFichero }}
            <span v-if="certificado.fecha"> - Periodo: del {{ formatLocalDate(certificado.fecha) }} al {{
              formatLocalDate(certificado.fechaFin) }}.</span>
          </span>
          <v-icon v-if="certificado.fecha" class="file-download">mdi-download</v-icon>
        </v-col>
      </v-row>

      <v-row>
        <v-col v-for="notificacion in notificaciones" cols="11" sm="9" v-bind:key="notificacion.idFirmaDocumento"
          class="mx-auto file-row" @click="downloadNotificacion(notificacion)">
          <span class="file-name">{{ notificacion.decripcionDocumento }}</span>
          <span v-if="!notificacion.fechaFirma" class="file-date">Documento no adjuntado</span>
          <span v-if="notificacion.fechaFirma" class="file-date">{{ notificacion.fechaFirma ?
            formatLocalDateTime(notificacion.fechaFirma) : '' }}</span>
          <v-icon v-if="notificacion.fechaFirma" class="file-download">mdi-download</v-icon>
        </v-col>
        <v-col v-if="pantalla && pantalla.id && pantalla.firma" cols="11" sm="9" class="mx-auto file-row"
          @click="downloadJustificante">
          <span class="file-name">Justificante de presentación de la solicitud </span>
          <span class="file-date">{{ pantalla.firma ? formatLocalDateTime(pantalla.firma) : '' }}</span>
          <v-icon class="file-download">mdi-download</v-icon>
        </v-col>
        <v-col v-if="pantalla && pantalla.id && pantalla.firma" cols="11" sm="9" class="mx-auto file-row"
          @click="downloadSolicitud">
          <span class="file-name">Solicitud de la prestación</span>
          <span class="file-date">{{ pantalla.firma ? formatLocalDateTime(pantalla.firma) : '' }}</span>
          <v-icon class="file-download">mdi-download</v-icon>
        </v-col>
      </v-row>

      <v-row v-if="archivos && archivos.length > 0">
        <v-col cols="11" sm="10" class="mx-auto mt-3">
          <b>Documentación adjuntada para la solicitud</b>
        </v-col>
        <v-col v-for="archivo in archivos" cols="11" sm="9" v-bind:key="archivo.idDocumento" class="mx-auto file-row"
          @click="downloadDocumento(archivo)">
          <span class="file-name">{{ archivo.descripcionTipo }}</span>
          <span v-if="!archivo.nombreArchivo" class="file-date">Documento no adjuntado</span>
          <span v-if="archivo.nombreArchivo" class="file-date">{{ archivo.nombreArchivo }} - {{ archivo.fechaArchivo ?
            formatLocalDateTime(archivo.fechaArchivo) : '' }}</span>
          <v-icon v-if="archivo.nombreArchivo" class="file-download">mdi-download</v-icon>
        </v-col>
      </v-row>

      <v-row
        v-if="!isLoading && (!notificaciones || notificaciones.length == 0) && (!listCertificados || listCertificados.length == 0) && !(pantalla && pantalla.id && pantalla.firma) && archivos.length == 0">
        <v-col cols="11" sm="10" class="mx-auto mt-3">
          <v-alert type="info">
            No hay documentación disponible
          </v-alert>
        </v-col>
      </v-row>

      <v-row cols="11" v-if="$store.state.solicitud.modoGestionInterno">
        <v-col cols="12" md="6">
          <v-btn class="btn-prev" @click="continuePrev" color="umivalesecondary">Anterior
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-overlay :value="showOverlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-content>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import api from '@Base/services/solicitudService'
import apiNotificacion from '@Base/services/notificacionService'
import apiAuditoria from '@Base/services/auditoriaService'
import StepBase from './common/StepBase'
import { Prestaciones } from './common/constants'

export default {
  name: 'DescargarDocumetacionMain',
  mixins: [StepBase],
  data() {
    return {
      isLoading: false,
      showOverlay: false,
      fechaFirma: null,
      mostrarEstado: false,
      emailSolicitud: null,
      telefonoSolicitud: null,
      archivos: [],
      listCertificados: [],
      notificaciones: [],
      certificado: {}, // en un principio es uno único, cambiar por [] en caso de que devuelva varios
      pantalla: {
        id: null,
        email: null,
        movil: null,
        estado: null,
        firma: null
      },
      mostrarAvisoFinSolicitud: false
    }
  },
  methods: {
    continuePrev: function () {
      if (this.$store.state.solicitud.modoGestionInterno === true)
        this.redirect(this.getFirstStep());
    },
    // eslint-disable-next-line no-unused-vars
    loadSolicitante: function (vm, params) {
      if (this.$refs.form != null) {
        this.$refs.form.resetValidation();
      }
      vm.mostrarAvisoFinSolicitud = false;
      this.tokenSolicitante = params.id;

      if (!this.tokenSolicitante) {
        this.$router.push({ name: 'no-direct-access' });
        return;
      }

      if ((!this.$store.state.solicitud.tokenGestion && !this.$store.state.solicitud.tokenGestionInterno) ||
        !this.$store.state.solicitud.solicitante || this.$store.state.solicitud.tokenAcceso != this.tokenSolicitante) {
        this.$router.push({ name: 'acceso', params: { id: this.tokenSolicitante } });
        return;
      }

      this.isLoading = true;
      this.tokenGestion = this.$store.state.solicitud.tokenGestion;
      const notificacionOrigen = this.$store.state.solicitud.idNotificacion

      this.getListCertificados();
      this.getResoluciones();
    },

    getListCertificados() {
      api.getListCertificados(this.$store.state.solicitud.solicitante.idSolicitante,
        data => {
          this.listCertificados = data;
        },
        error => {
          this.$emit('alert-event', { text: 'Error al obtener el listado de certificados', color: 'red' });
          console.log(error);
        }
      );
    },

    getResoluciones() {
      api.getResoluciones(this.$store.state.solicitud.solicitante.idSolicitante,
        data => {
          this.notificaciones = data;
          this.getDocumentos();
        },
        error => {
          this.$emit('alert-event', { text: 'Error al cargar las resoluciones', color: 'red' });
          console.log(error);
        }
      );
    },
    downloadJustificante() {
      this.showOverlay = true;
      api.getDocumentoJustificante(() => { this.showOverlay = false; }, () => { this.showOverlay = false; });
    },
    downloadSolicitud() {
      this.showOverlay = true;
      api.getDocumentoNotificacion(this.pantalla.id, () => { this.showOverlay = false; }, () => { this.showOverlay = false; });
    },

    downloadCertificado(certificado) {
      if (!certificado.fecha) return;
      this.showOverlay = true;
      apiNotificacion.getCertificado(this.tokenGestion, certificado.url,
        () => {
          this.showOverlay = false;
        },
        error => {
          this.showOverlay = false;
          this.$emit('alert-event', { text: 'Error al descargar el certificado', color: 'red' });
          console.log(error);
        });
    },

    downloadNotificacion(notificacion) {
      if (!notificacion.fechaFirma) return;

      this.showOverlay = true;
      apiNotificacion.getDocumento(this.tokenGestion, notificacion.idFirmaDocumento,
        () => {
          this.showOverlay = false;
        },
        error => {
          this.showOverlay = false;
          this.$emit('alert-event', { text: 'Error al descargar el documento', color: 'red' });
          console.log(error);
        });
    },
    downloadDocumento(archivo) {
      if (!archivo.nombreArchivo) return;

      this.showOverlay = true;
      api.getDocumento(archivo.idDocumento, () => { this.showOverlay = false; }, () => { this.showOverlay = false; });
    },
    getDocumentos() {
      this.isLoading = true;
      const idNotificacionOrigen = this.$store.state.solicitud.idNotificacion
      api.getDocumentos(idNotificacionOrigen,
        documentos => {
          this.archivos = documentos;
          this.isLoading = false;
        },
        error => {
          this.isLoading = false;
          this.$emit('alert-event', { text: 'Error al obtener los documentos', color: 'red' });
          console.log(error);
        }
      );
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.$store.commit('solicitud/setTituloModulo', this.$store.state.solicitud.solicitante.tituloPrestacion);
      this.loadSolicitante(this, to.params);
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (!vm.$store.state.solicitud.solicitante) {
        vm.$router.push({ name: 'acceso', params: { id: to.params.id } });
        return;
      }
      vm.$store.commit('solicitud/setTituloModulo', vm.$store.state.solicitud.solicitante.tituloPrestacion);
      vm.loadSolicitante(vm, to.params);
    })
  }
}
</script>


<style scoped>
.file-row {
  border-bottom: #ccc 1px solid;
  cursor: pointer;
}

.file-name {
  display: block;
  font-size: 16px;
}

.file-date {
  display: block;
  font-size: 12px;
}

.file-download {
  margin-top: -24px;
  color: #124D91;
  cursor: pointer;
  float: right;
}
</style>